import { produce } from "immer";
import { atom, getDefaultStore } from "jotai";
import { TypedEventEmitter } from "src/utils/EventEmitter";

const store = getDefaultStore();

export declare type ErrorMessage = { header: string, message: string, htmlMessage?: string, when: Date }

const errorsAtom = atom<ErrorMessage[]>([]);
errorsAtom.debugLabel = "errorsAtom";

export const allErrorsAtom = atom( (get) =>  get(errorsAtom)  );
allErrorsAtom.debugLabel = "allErrorsAtom";

export const errorEventEmitter:TypedEventEmitter<ErrorMessage[]> = new TypedEventEmitter<ErrorMessage[]>();

export const ErrorService ={



    setError: (err: ErrorMessage) => {
        const errors = store.get(errorsAtom);
        const newData = [...errors, err];
        store.set( errorsAtom, newData );
        errorEventEmitter.emit("errorChanged", newData);
    },

     setErrors: (err: ErrorMessage[]) => {
        const errors = store.get(errorsAtom);
        const newData = [...errors, ...err];
        store.set( errorsAtom, newData );
        errorEventEmitter.emit("errorChanged", newData);
    },

    getError: ()=>{

        const errors = store.get(errorsAtom);
        if( errors.length === 0 ) return null;
        return errors[errors.length -1];
    },

    clearError: (err: ErrorMessage) => {
        const errors = store.get(errorsAtom);
        const newData = errors.filter( e => e.when !== err.when );
        store.set( errorsAtom, newData);
        
    },

    clearAllErrors: () => {
        store.set( errorsAtom, []);
    }
}